import apiUrl from '../../../../constants';
import axios from 'axios';
import vSelect from 'vue-select';
import DatePicker from 'vue2-datepicker';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import { BasicSelect } from 'vue-search-select'

export default {
    name: 'newchannelmapping',
    components: {
        vSelect,
        DatePicker,
        VueElementLoading,
        BasicSelect
    },
    props: [],
    data() {
        return {
            isLoading: false,
            channelErrors: {},
            showSelectClient: false,
            showSelectWarehouse: false,
            listClientData: [],
            listWarehouseData: [],
            saleschannellist: [],
            referenceNo: '',
            createdbyEmail: '',
            client:'',
            warehouse:'',
            clientid: '',
            clientToken: '',
            warehouseid: '',
            warehouseName: '',
            modalMessageShowpo: false,

            //form data
            addChannel: {
                clientid: '',
                warehouseid: '',
                channelname: '',
                saleschannel: '',
                uniwarewarehouse: '',
                warehousename: '',
                thirdpartyshipping: '',
                specialpackinginstruction:'',
            },
            clientItem: {},
            warehouseItem:{},
            salesChannelItem:{}
        };
    },
    computed: {},
    mounted() {

        var userdetailEncrypt = window.localStorage.getItem('userdetail')
        var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        var userdetail = JSON.parse(plaintext);
        this.user_type = userdetail.utype;
        this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
        this.addChannel.clientid=this.clientid;
        this.addChannel.warehouseid=this.warehouseid;
        this.getSalesChannels();
        this.addWarehouseList();
        switch (this.user_type) {
            case 'system_user':
                console.log("system_user")
                this.showSelectClient = true;
                this.showSelectWarehouse = true;
                this.createdbyEmail = userdetail.email;
                // this.getClientList();
                // this.getWarehouseList();
                break;

            case 'client_user':
                console.log("client_user")
                this.clientid = this.addChannel.clientid = userdetail.clientid;
                this.createdbyEmail = userdetail.email;
                this.showSelectWarehouse = true;
                // this.getClientList();
                // this.getWarehouseList();
                break;

            case 'warehouse_user':
                console.log("warehouse_user")
                this.warehouseid = this.addChannel.warehouseid = userdetail.warehouseid;
                this.createdbyEmail = userdetail.email;
                this.showSelectClient = true;
                // this.getClientList();
                // this.getWarehouseList();
                break;

            default:
                console.log("default")
                this.$alertify.error("Unauthorised user, Please contact your system admin");
                break
        }
    },
    methods: {
        showList() {
            this.modalMessageShowpo = false;
            this.warehouseItem.value=this.warehouseItem.value;
            this.$emit("goBackToParent", this.clientItem, this.warehouseItem)
        },
        async saveChannelMapping() {

            var userToken = window.localStorage.getItem('userToken');
            var myStr = userToken.replace(/"/g, '');
            if (this.onSubmitForm()) {
                await this.getClientToken(this.clientid);
                if(!this.addChannel.warehousename){
                    this.addChannel.warehousename= await this.getWarehouseName(window.localStorage.getItem('selectedWarehouse'));
                }
                if (!this.clientToken) {
                    this.$alertify.error("Invalid Client token");
                    return;
                }
                this.isLoading = true
                await axios({
                    method: 'POST',
                    'url': apiUrl.api_url + 'newChannelMapping',
                    'data': {
                        'clientid': window.localStorage.getItem('selectedClient'),
                        'warehouseid': window.localStorage.getItem('selectedWarehouse'),
                        'channelname': this.addChannel.channelname.trim(),
                        'saleschannel': this.addChannel.saleschannel,
                        'createdby': this.createdbyEmail,
                        'clienttoken': this.clientToken,
                        'warehousename': this.addChannel.warehousename,
                        'uniwarewarehouse': this.addChannel.uniwarewarehouse.trim(),
                        'thirdpartyshipping': this.addChannel.thirdpartyshipping,
                        'specialpackinginstruction':this.addChannel.specialpackinginstruction
                    },
                    headers: {
                        'Authorization': 'Bearer ' + myStr
                    }
                })
                    .then((response) => {
                        if (response.data.data[0].ErrorCode == 0) {
                            this.isLoading = false
                            this.$alertify.success(response.data.data[0].msg)
                            this.modalMessageShowpo = true;
                        } else if (response.data.data[0].ErrorCode == -1) {
                            this.isLoading = false
                            this.$alertify.error(response.data.data[0].msg)
                        }
                    })
                    .catch((httpException) => {
                        console.error('exception is:::::::::', httpException)
                    })
            }
        },
        // getClientList() {
        //     if (window.localStorage.getItem("clientList") !== null) {
        //         var clientListEncrypt = window.localStorage.getItem('clientList');
        //         var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
        //         var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
        //         this.getClientSelectOptions(JSON.parse(plaintextclient));
        //     } else {
        //         var userToken = window.localStorage.getItem('userToken');
        //         var myStr = userToken.replace(/"/g, '');
        //         axios({
        //             method: 'POST',
        //             'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
        //             'data': {},
        //             headers: {
        //                 'Authorization': 'Bearer ' + myStr,
        //             }
        //         })
        //             .then(result => {
        //                 this.getClientSelectOptions(result.data.data);
        //             }, error => {
        //                 console.error(error);
        //             });
        //     }
        // },
        addWarehouseList() {
            if (window.localStorage.getItem("warehouseList") !== null) {
                var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
                var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
                var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
                this.getWarehouseSelectOptions(JSON.parse(plaintextwarehouse));
            } else {
                var userToken = window.localStorage.getItem('userToken')
                var myStr = userToken.replace(/"/g, '');
                this.input = ({
                    clientid: this.clientid,
                });

                axios({
                    method: 'POST',
                    'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
                    'data': this.input,
                    headers: {
                        'Authorization': 'Bearer ' + myStr
                    }
                })
                    .then(result => {
                        this.getWarehouseSelectOptions(result.data.data);
                    }, error => {
                        console.error(error)
                    })
            }
        },
        getSalesChannels() {
            var userToken = window.localStorage.getItem('userToken');
            var myStr = userToken.replace(/"/g, '');
            if (this.clientid == '') {
                return;
            }
            axios({
                method: 'POST',
                'url': apiUrl.api_url + 'orderSalesChannelList',
                'data': {
                    clientid: this.clientid
                },
                headers: {
                    'Authorization': 'Bearer ' + myStr,
                }
            })
                .then(result => {
                    this.getSalesChannelSelectOptions(result.data.data);
                }, error => {
                    console.error(error);
                });
        },
        resetForm() {
            this.clientItem={};
            this.warehouseItem={};
            this.salesChannelItem={};
            this.addChannel.clientid = '';
            this.addChannel.warehouseid = '';
            this.addChannel.channelname = '';
            this.addChannel.saleschannel = '';
            this.addChannel.uniwarewarehouse = '';
            this.addChannel.warehousename = '';
            this.addChannel.thirdpartyshipping = '';
            this.addChannel.specialpackinginstruction = '';
        },
        clientSelected(item) {
            this.clientItem=item;
            if(this.clientid != this.clientItem.value){
                this.addChannel.clientid = item.value;
                this.clientid = this.addChannel.clientid;
                this.addChannel.saleschannel = '';
                this.saleschannellist = [];
                this.salesChannelItem={};
                this.getSalesChannels();
                if (this.user_type != 'warehouse_user') {
                    this.warehouseid='';
                    this.addChannel.warehouseid='';
                    this.listWarehouseData = [];
                    this.warehouseItem={};
                    this.getWarehouseList();
                  }
            }
        },
        warehouseSelected(item) {
            this.warehouseItem=item;
            this.addChannel.warehouseid=window.localStorage.getItem('selectedWarehouse');
            this.addChannel.warehousename=item.text;
            this.warehouseid = this.addChannel.warehouseid;
            if (this.warehouseid) {
                if (!this.clientid) {
                    this.getClientList();
                } else {
                    this.getSalesChannels();
                }
            }
        },

        //validate all form fields on onsubmit()
        onSubmitForm() {
            this.channelErrors = {};

            if (!this.addChannel.clientid)
                this.channelErrors.clientid = this.$t('product.pleaseSelectClient');
            if (!this.addChannel.warehouseid)
                this.channelErrors.warehouseid = this.$t('purchaseOrder.shipWarehouse');
            if (!this.addChannel.channelname.trim())
                this.channelErrors.channelname = this.$t('unicommerce.channelmapping.channelNameErr');
            if (!this.addChannel.saleschannel)
                this.channelErrors.saleschannel = this.$t('unicommerce.channelmapping.saleChannelErr');
            if (!this.addChannel.uniwarewarehouse.trim())
                this.channelErrors.uniwarewarehouse = this.$t('unicommerce.channelmapping.uniwareWarehouseErr');
            if (!this.addChannel.thirdpartyshipping)
                this.channelErrors.thirdpartyshipping = this.$t('unicommerce.channelmapping.thirdPartyShippingErr');
            if(!this.addChannel.specialpackinginstruction)
                this.addChannel.specialpackinginstruction = this.$t('unicommerce.channelmapping.specialpackinginstructionErr')
            if (Object.keys(this.channelErrors).length == 0) {
                return true;
            } else {
                return false;
            }
        },
        getClientToken(clientid) {
            var userToken = window.localStorage.getItem('userToken');
            var myStr = userToken.replace(/"/g, '');
            return axios({
                method: 'POST',
                'url': apiUrl.api_url + 'generateClientToken',
                'data': { "clientid": clientid },
                headers: {
                    'Authorization': 'Bearer ' + myStr,
                }
            })
                .then(result => {
                    this.clientToken = result.data.token;
                }, error => {
                    console.error(error);
                });
        },
        getWarehouseName(warehouseid) {
            console.log(typeof(warehouseid))
            console.log(typeof(this.listWarehouseData[1].value))
            if (this.listWarehouseData.length > 0) {
                for (let warehouse of this.listWarehouseData) {
                    if (JSON.stringify(warehouse.value) === warehouseid) {
                        console.log(warehouse.text)
                        return warehouse.text;
                    }
                }
            }
            return '';
        },
        getClientSelectOptions(data){
            this.clientItem = {
                value: '',
                text: ''
            };
            this.listClientData = [{
                value: '',
                text: this.$t('common.clientPlaceholder')
            }];
            data.forEach(ele => {
                this.listClientData.push({
                    "value": ele.clientid,
                    "text": ele.clientname
                })
            })
        },
        getWarehouseSelectOptions(data){
            this.warehouseItem = {
                value: '',
                text: ''
            };
            this.listWarehouseData = [{
                value: '',
                text: this.$t('common.warehousePlaceholder')
            }];
            data.forEach(ele => {
                this.listWarehouseData.push({
                    "value": ele.warehouseid,
                    "text": ele.warehousename
                })
            })
        },
        salesChannelSelected(item){
            this.salesChannelItem=item;
            this.addChannel.saleschannel=item.value;
        },
        getSalesChannelSelectOptions(data){
            this.salesChannelItem = {
                value: '',
                text: ''
            };
            this.saleschannellist = [{
                value: '',
                text: this.$t('orders.salesChannelPlaceHolder')
            }];
            data.forEach(ele => {
                this.saleschannellist.push({
                    "value": ele.saleschannel,
                    "text": ele.saleschannel
                })
            })
        },

    }

};



// WEBPACK FOOTER //
// ./src/views/components/uniware/newchannelmapping/newchannelmapping.component.js